// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"272":"621cde1b","279":"1e1e12e4","454":"4f6316de","467":"1e1e12e4","515":"1e1e12e4","565":"1e1e12e4","679":"0d0ca740"}[chunkId] + ".chunk.css";
};